import React, { useState } from 'react';
import './Login.css';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from './firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';

function Login() {
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const navigate = useNavigate(); // Initialize useNavigate

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      console.log('Logged in successfully');
      navigate('/Mainproject'); // Redirect to the main project page after successful login
    } catch (err) {
      console.log('Error logging in:', err);
    }
  };

  return (
    <div className='login-page'>
      <div className='Login-container'>
        <form className='signup-form' onSubmit={handleSubmit}>
          <h2>Login</h2>
          <label htmlFor='email'>
            Email:
            <input type="text" onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label htmlFor='password'>
            Password:
            <input type="password" value={password} onChange={handlePasswordChange} />
          </label>
          <button type="submit">Login</button>
          <p>Don't have an account? <Link to="/signup">Sign up</Link></p>
        </form> 
      </div>
    </div>
  );
}

export default Login;
